module.exports = __webpack_public_path__ + "img/ms_b3_img4.ceaa0374.png";